<template>
  <div>
    <order-list></order-list>
  </div>
</template>
<script>
import OrderList from './orderlist'

export default {
  components: {OrderList},
  data () {
    return {}
  },
  created () {

  },
  methods: {}
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/order/order/index.vue